import { useCallback, useState } from 'react';

export type SectionCollapseStates = Record<string, boolean>;

export type UseSectionCollapseStatesResult = {
  states: SectionCollapseStates;
  onSectionToggle: (sectionId: string, isOpen: boolean) => void;
};

export const useSectionCollapseStates = (
  initialStates: SectionCollapseStates = {}
): UseSectionCollapseStatesResult => {
  const [states, setStates] = useState<SectionCollapseStates>(initialStates);

  const onSectionToggle = useCallback((sectionId: string, isOpen: boolean) => {
    setStates((prev) => ({ ...prev, [sectionId]: !isOpen }));
  }, []);

  return { states, onSectionToggle };
};
